export default {
    methods: {
        showPassword(e, pid) {
            let el = e.target;
            let x = document.getElementById(pid);

            if (x.type === 'password') {
                x.type = 'text';
                el.classList.remove("fa-eye");
                el.classList.add("fa-eye-slash");
            } else {
                x.type = 'password';
                el.classList.remove("fa-eye-slash");
                el.classList.add("fa-eye");
            }
        },
        go2Top() {
            $("html, body").animate({scrollTop: 0}, "slow");
            return false;
        },
        go2(selector) {
            if (!$(selector).length) {
                return;
            }

            $([document.documentElement, document.body]).animate({
                scrollTop: $(selector).offset().top
            }, "slow");
        },
        onError(error) {
            let self = this;
            let msg = '';

            self.loading = false;

            if (error.response && (error.response.status === 403 || error.response.status === 401)) {
                msg = 'یک خطا رخ داد!';
                self.$root.toastr.error(msg);
                return;
            }


            if (error.response) {
                if (error.response.data && error.response.data.message) {
                    if (error.response.data.message === 'An error has occurred.') {
                        self.$root.toastr.error('یک خطا رخ داد!');
                    } else {
                        if (error.response.data.message === 'The given data was invalid.') {
                            msg = '<div class="ml-2"><div class="font-weight-bold"></div>';
                        } else {
                            msg = '<div class="ml-2"><div class="font-weight-bold">' +
                                error.response.data.message + '</div>';
                        }

                        if (error.response.data.errors) {
                            msg = msg + '<ul class="mt-2">';
                            for (let attr in error.response.data.errors) {
                                if (error.response.data.errors.hasOwnProperty(attr)) {
                                    error.response.data.errors[attr].forEach(function (txt) {
                                        msg = msg + '<li>' + txt + '</li>';
                                    });
                                }
                            }
                            msg = msg + '</ul></div>';
                        }

                        self.$root.toastr.error(msg);
                    }
                } else {
                    self.$root.toastr.error(error.response.statusText);
                }
            }
        },
        clearCache() {
            let self = this;

            self.$root.loading = true;
            axios.get('api/admin/cache/clear')
                .then((response) => {
                    self.$root.loading = false;
                    self.$root.toastr.success(response.data.message);
                })
                .catch((error) => {
                    self.$root.onError(error);
                });
        },
    },
    mounted() {
        window.$ = window.jQuery;
        $(window).scroll(function () {
            let height = $(window).scrollTop();
            if (height > 100) {
                $('#go2Top').fadeIn();
            } else {
                $('#go2Top').fadeOut();
            }
        });
    }
}
